import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableInboundInventory = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableInboundInventory);
};
